import { updates } from '@/mocks/updates';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              最新快讯
            </h2>
            <p className="text-sm text-foreground-500 mt-1">分秒必争的娱乐圈动态</p>
          </div>
          <span className="flex items-center gap-1.5 text-xs text-primary-500">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
            实时更新中
          </span>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-6 before:absolute before:left-[7px] before:top-2 before:bottom-2 before:w-0.5 before:bg-background-200">
            {updates.map((item) => (
              <div key={item.id} className="relative mb-5 last:mb-0">
                <div className="absolute -left-[25px] top-1.5 w-[11px] h-[11px] rounded-full bg-primary-500 border-2 border-background-100"></div>

                <div className="flex items-start gap-3 flex-wrap">
                  <span className="text-[10px] text-foreground-400 whitespace-nowrap mt-0.5">
                    {item.time}
                  </span>
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap mt-0.5 font-medium ${
                      item.tag === '突发'
                        ? 'bg-accent-100 text-accent-700'
                        : item.tag === '爆料'
                          ? 'bg-primary-100 text-primary-700'
                          : item.tag === '首发'
                            ? 'bg-accent-100 text-accent-700'
                            : item.tag === '确认'
                              ? 'bg-secondary-100 text-secondary-700'
                              : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {item.tag}
                  </span>
                  <p className="text-sm text-foreground-800 leading-relaxed flex-1 min-w-0">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}